import React, { useEffect, useState } from "react";
import Loader from "../../components/shared/Loader";
import { Link } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";

const WorksIndex = () => {
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const [filterType, setFilterType] = useState("all");
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "جميع الأعمال",
				breadcrumb: "الأعمال",
				button: {
					show: true,
					text: "اضافة عمل جديد",
					link: "/works/create",
				},
			})
		);

		setLoading(true);

		axios
			.get(`${process.env.REACT_APP_API_URL}/posts/our_works/all`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(response => {
				setData(response.data.data);
				setLoading(false);
			})
			.catch(() => {
				toast.error("خطأ، برجاء المحاولة لاحقًا!");
				setLoading(false);
			});
	};

	const handleDelete = workID => {
		axios
			.delete(`${process.env.REACT_APP_API_URL}/posts/${workID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(() => {
				onStart();
			})
			.catch(() => {
				toast.error("خطأ، برجاء المحاولة لاحقًا!");
			});
	};

	const filterPosts = (posts = []) => {
		if (filterType === "videos") {
			return posts.filter(post =>
				[".mp4", ".mov", ".avi", ".webm"].some(ext =>
					post.data.image?.toLowerCase().endsWith(ext)
				)
			);
		}

		if (filterType === "images") {
			return posts.filter(post =>
				[".jpg", ".jpeg", ".png", ".gif", ".webp"].some(ext =>
					post.data.image?.toLowerCase().endsWith(ext)
				)
			);
		}

		return posts;
	};

	return (
		<section className="works">
			{loading && <Loader />}

			{data.map(item =>
				item.categories.map(category => (
					<div key={category.id}>
						<h1 className="itemTitle">{category.title.ar}</h1>

						<div className="tabs mb-4">
							<button
								onClick={() => {
									setFilterType("all");
								}}
								className={`tab ${filterType === "all" ? "active" : ""}`}
							>
								جميع الأعمال
							</button>
							<button
								onClick={() => setFilterType("videos")}
								className={`tab ${filterType === "videos" ? "active" : ""}`}
							>
								الفيديوهات
							</button>
							<button
								onClick={() => setFilterType("images")}
								className={`tab ${filterType === "images" ? "active" : ""}`}
							>
								الصور
							</button>
						</div>

						<div className="row">
							{filterPosts(category.posts).length > 0 ? (
								filterPosts(category.posts).map(post => (
									<div
										key={post.id}
										className="col-md-4 col-lg-3 col-sm-6 col-6"
									>
										<div className="serviceItem">
											<button onClick={() => handleDelete(post.id)}>
												<i className="fas fa-trash" />
											</button>

											<Link to={`/works/show/${post.id}`}>
												{[".mp4", ".mov", ".avi", ".webm"].some(ext =>
													post.data.image?.toLowerCase().endsWith(ext)
												) ? (
													<video
														src={`${process.env.REACT_APP_MAIN_URL}${post.data.image}`}
														controls
														style={{ width: "100%" }}
													/>
												) : (
													<img
														src={`${process.env.REACT_APP_MAIN_URL}${post.data.image}`}
														alt={post.data.title.ar}
													/>
												)}

												<h1>{post.data.title.ar}</h1>
											</Link>
										</div>
									</div>
								))
							) : (
								<h3 className="bg-success text-center text-white my-5 py-4 w-100">
									لا يوجد اعمال
								</h3>
							)}
						</div>
					</div>
				))
			)}
		</section>
	);
};

export default WorksIndex;
